import getFacesReseauAsync from '@/services/reseauxTempo/getFaces';
import getAnneeSemaine, { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';
import {
  PANNEAUX_FROM_VENTES_LC,
  PANNEAUX_FROM_VENTES_NUMERIQUES,
} from '@/configuration/carteConf';

function getFaceCode(face, typeProduit) {
  switch (typeProduit) {
    case PANNEAUX_FROM_VENTES_LC:
      return face.extensionOpportunite.faceSelectionne.facCode;
    case PANNEAUX_FROM_VENTES_NUMERIQUES:
      return face.code;
    default:
      return face.facCode;
  }
}

export default async function getFacesReseauPerso(panier, reseau) {
  const faces = [];

  // récupération des faces: panneauxLc
  panier.produits.panneauxLc.forEach((el) => {
    if (el.extensionOpportunite.reseauPersoGuid === reseau.guid) {
      const face = Object.assign({}, el);
      face.facCode = getFaceCode(el, PANNEAUX_FROM_VENTES_LC);
      face.libelleReseau = reseau.libelle;
      faces.push(face);
    }
  });

  // récupération des faces: reseauxNumeriques
  panier.produits.reseauxNumeriques.forEach((el) => {
    if (el.extensionOpportunite.reseauPersoGuid === reseau.guid) {
      el.listeFaces.forEach((face) => {
        face.libelleReseau = reseau.libelle;
        faces.push(face);
      });
    }
  });

  // récupération des faces: reseauxLc
  panier.produits.reseauxLc.forEach((el) => {
    if (el.extensionOpportunite.reseauPersoGuid === reseau.guid) {
      el.listeFaces.forEach((face) => {
        face.libelleReseau = reseau.libelle;
        faces.push(face);
      });
    }
  });

  // récupération des faces: panneauxNumeriques
  panier.produits.panneauxNumeriques.forEach((el) => {
    if (el.extensionOpportunite.reseauPersoGuid === reseau.guid) {
      const face = Object.assign({}, el);
      face.facCode = getFaceCode(el, PANNEAUX_FROM_VENTES_NUMERIQUES);
      face.libelleReseau = reseau.libelle;
      faces.push(face);
    }
  });

  // récupération des faces: reseauxTempo
  const promesses = [];
  panier.produits.reseauxTempo.forEach((el) => {
    if (el.extensionOpportunite.reseauPersoGuid === reseau.guid) {
      const dateDebut = getDateByJourAnneeSemaine(
        el.jourDepart,
        el.extensionOpportunite.annee,
        el.extensionOpportunite.semaine);
      const query = {
        params: {
          dateVisualisation: dateDebut.format('YYYYMMDD'),
          anneeSemaine: getAnneeSemaine(
            el.extensionOpportunite.annee, el.extensionOpportunite.semaine),
          jourDepart: el.jourDepart,
          societeId: el.socCode,
        },
      };
      promesses.push(getFacesReseauAsync(el.num, query));
    }
  });
  const response = await Promise.all(promesses);
  response.flat().forEach((face) => {
    face.libelleReseau = reseau.libelle;
    faces.push(face);
  });

  if (faces.length === 0) {
    return reseau.produitsWithAllData.map(el => ({
      ...el.dataProduit,
      libelleReseau: reseau.libelle,
      facCode: getFaceCode(el.dataProduit, el.typeProduit),
    }));
  }
  return faces;
}



// WEBPACK FOOTER //
// ./src/services/panier/getFacesReseauPerso.js